import { IUser } from './IUser';

export class User implements IUser {
  id?: string;
  contactId?: string;
  accessToken: string;
  keepSignedIn?: boolean;
  loginName: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  companyAddressbookId?: string;
  avatar?: string;

  constructor(o: Partial<User> = <User>{}) {
    Object.assign(this, o);
  }
}
